import { render, staticRenderFns } from "./GExamDetailProgressClassCharts.vue?vue&type=template&id=4ebffde6&scoped=true&"
import script from "./GExamDetailProgressClassCharts.vue?vue&type=script&lang=ts&"
export * from "./GExamDetailProgressClassCharts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebffde6",
  null
  
)

export default component.exports